import { useCallback } from 'react';
import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { LazyComponent, ScrollableComponent } from '#src/app/shared/components/layout/lazy';

import { LocalSectionSkeleton } from '../skeletons';

export const LazyLocalSection: React.FC = () => {
	const loadComponent = useCallback(
		async () => (await import(/* webpackChunkName: "pages/homepage-localSection" */ '../LocalSection')).LocalSection,
		[],
	);

	return (
		<ClientRender placeholder={<LocalSectionSkeleton />}>
			<ScrollableComponent topOffset={200} immediateForBots fallback={<LocalSectionSkeleton />}>
				<LazyComponent loadComponent={loadComponent} fallback={<LocalSectionSkeleton />} />
			</ScrollableComponent>
		</ClientRender>
	);
};
